import React, { useState, ReactNode } from 'react';

import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { ModalContainer } from 'components/Modals/ModalContainer';
import { RESTORE_PASSWORD_MODAL_DATA } from 'shared/constants/modal-constants';
import { EnterEmailForm } from 'components/Forms/EnterEmailForm/EnterEmailForm';
import { closeCurrentModal, openCurrentModal } from 'redux/slices/modals/modals.slice';
import { useAppDispatch, useAppSelector } from 'redux/hooks/reduxHooks';
import { selectCurrentModal } from 'redux/selectors/selectors';
import { EModalsNames } from 'shared/types/modal.interface';
import { LinkExplanation } from '../LinkExplanation/LinkExplanation';

type TRestorePasswordModalData = {
  subtitle: string;
  component: ReactNode;
};

export const RestorePasswordModal: React.FC = () => {
  const currentModal = useAppSelector(selectCurrentModal);
  const [currentEmail, setCurrentEmail] = useState('');
  const dispatch = useAppDispatch();

  const RESTORE_PASSWORD_MODAL_COMPONENTS: TRestorePasswordModalData[] = [
    {
      subtitle: RESTORE_PASSWORD_MODAL_DATA.subtitle1,
      component: <EnterEmailForm setCurrentEmail={setCurrentEmail} defaultEmail={currentEmail} />,
    },
    {
      subtitle: `${RESTORE_PASSWORD_MODAL_DATA.subtitle2}${currentEmail}`,
      component: (
        <LinkExplanation
          onClick={() => {
            // todo: add some logic onClick (fetch new link)
            dispatch(
              openCurrentModal({ popupName: EModalsNames.RestorePasswordModal, data: { type: 0 } }),
            );
          }}
        />
      ),
    },
  ];

  if (currentModal.entityName !== EModalsNames.RestorePasswordModal) return null;

  return (
    <ModalContainer
      onClose={() => dispatch(closeCurrentModal())}
      isOpen={currentModal.entityName === EModalsNames.RestorePasswordModal}
    >
      <Stack alignItems="center" width="100%">
        <Typography variant="h2" color="primary.main" pb="8px">
          {RESTORE_PASSWORD_MODAL_DATA.title}
        </Typography>
        <Typography variant="subtitle1" color="primary.main" textAlign="center" sx={{ p: 0 }}>
          {RESTORE_PASSWORD_MODAL_COMPONENTS[currentModal.data.type].subtitle}
        </Typography>
        {RESTORE_PASSWORD_MODAL_COMPONENTS[currentModal.data.type].component}
      </Stack>
    </ModalContainer>
  );
};
